import React from 'react';

export default function PlusBoldIcon() {
    return (
        <svg xmlns='http://www.w3.org/2000/svg' width='15' height='16' fill='none' viewBox='0 0 15 16'>
            <path fill='#fff' d='M5.625.5v5.625H0v3.75h5.625V15.5h3.75V9.875H15v-3.75H9.375V.5h-3.75z' />
        </svg>
    );
}
